// Box-score links for bracket games, matching the public schedule table: basketball
// stats games first, then other sports' saved box scores. Only final games with stats get one.
const isFinal = (m) => !!m.winner || !!m.forfeit_team || (m.score_a != null && m.score_b != null);

export function statsHref(event, match, shareToken) {
  if (!isFinal(match)) return null;
  const share = shareToken ? `share=${shareToken}` : '';
  const sg = event?.stats_game_by_match?.[match.id];
  if (sg?.id && sg.status === 'completed') return `/stats/summary/${sg.id}${share ? `?${share}` : ''}`;
  if ((event?.sport_box_score_match_ids || []).includes(match.id)) return `/stats/match/${match.id}?event=${event.id}${share ? `&${share}` : ''}`;
  return null;
}

export function statsLinksFor(event, shareToken) {
  const out = {};
  (event?.schedule || []).forEach((m) => {
    const href = statsHref(event, m, shareToken);
    if (href) out[m.id] = href;
  });
  return out;
}
